module.exports = __webpack_public_path__ + "img/delivery-bg.fca1e2f8.jpg";